import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import Button from 'components/common/Button';
import withConfirm from 'hooks/withConfirm';
import SectionHeader from './SectionHeader';

const ChatNotification = ({ data, onSave, onDelete, role, trigger, confirm }) => {
  const [message, setMessage] = useState();
  const [template, setTemplate] = useState();
  const [productType, setProductType] = useState(null);

  useEffect(() => {
    const tmpl = data.find((i) =>
      productType ? i.product_type === productType : !i.product_type,
    );
    setMessage(tmpl ? tmpl.body : '');
    setTemplate(tmpl);
  }, [productType]);

  const handleSave = () => {
    return onSave({
      id: template?.id,
      body: message,
      recipient_role: role,
      delivery_type: 'chat',
      event_trigger: trigger,
      product_type: productType,
    });
  };

  const handleDelete = () => {
    confirm(() => onDelete(template.id));
  }

  return (
    <Box marginBottom={3}>
      <Card>
        <SectionHeader
          title="Chat message"
          setProductType={setProductType}
          productType={productType}
        />
        <CardContent>
          <TextField
            fullWidth
            variant="outlined"
            label="Chat notification message"
            rows={5}
            multiline
            value={message}
            onChange={e => setMessage(e.target.value)}
          />
          <Box marginTop={2} display="flex" justifyContent="space-between">
            <Button color="primary" variant="contained" onClick={handleSave}>
              Save
            </Button>
            {template && (
              <Button color="secondary" onClick={handleDelete}>Delete</Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default withConfirm(ChatNotification);
